import React from 'react';
import { Segment, Header, Tab } from 'semantic-ui-react';
import ActionStatsTable from '../../components/ActionStatsTable';
import ActionLogsTable from '../../components/ActionLogsTable';

const Action = () => {
  const panes = [
    {
      menuItem: 'Action 统计',
      render: () => (
        <Tab.Pane attached={false}>
          <ActionStatsTable />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Action 日志',
      render: () => (
        <Tab.Pane attached={false}>
          <ActionLogsTable />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <Segment>
        <Header as='h3'>Action 管理</Header>
        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
      </Segment>
    </>
  );
};

export default Action;
